import { Button } from '@components/ui/button';
import { PredefinedPeriod } from '../types';
import { useTranslation } from 'react-i18next';
import { parseToDateRange } from '../helpers';
import { CalendarOptionsButtonProps } from './types';

export const CalendarOptionsButton = ({ value, range, onChange }: CalendarOptionsButtonProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'forms.default.date.options' });

  const handleOption = (option: PredefinedPeriod) => {
    if (!onChange) return;
    return onChange(parseToDateRange(option));
  };

  return (
    <Button
      className="h-fit w-32 border text-xs"
      key={value}
      onClick={() => handleOption(value)}
      size="sm"
      variant={value === range ? 'default' : 'secondary'}>
      {t(value)}
    </Button>
  );
};
